import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    infoStudent: {},
    infoStudentExpired: {},
    examinationRooms: [],
    infoReception: {},
  },
  getters: {
    infoStudent: state => state.infoStudent,
    examinationRooms: state => state.examinationRooms,
    infoStudentExpired: state => state.infoStudentExpired,
    infoReception: state => state.infoReception,
  },
  mutations: {
    SET_INFO_STUDENT: (state, infoStudent) => { state.infoStudent = infoStudent },
    SET_INFO_STUDENT_EXPIRED: (state, infoStudentExpired) => { state.infoStudentExpired = infoStudentExpired },
    SET_EXAMINATION_ROOMS: (state, examinationRooms) => { state.examinationRooms = examinationRooms },
    SET_RECEPTION: (state, value) => { state.infoReception = value },
  },

  actions: {
    async getInfoStudent({ commit }, id) {
      try {
        const response = await axios.get(`uni/students/${id}`)
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_INFO_STUDENT', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async getListExamination({ commit }, params) {
      try {
        const response = await axios.get('uni/students/getListExamination', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_EXAMINATION_ROOMS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    // eslint-disable-next-line no-unused-vars
    async updateInfoStudent({ commit }, params) {
      try {
        const response = await axios.post('uni/students/update', params)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },

    // eslint-disable-next-line no-unused-vars
    async uploadAvatar({ commit }, params) {
      try {
        const response = await axios.post('uni/students/uploadAvatar', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },

    // eslint-disable-next-line no-unused-vars
    async changePassword({ commit }, { id, body }) {
      try {
        const response = await axios.put(`uni/accounts/${id}/changePassword`, body)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },

    async getInfoStudentAboutToExpired({ commit }, params) {
      try {
        const response = await axios.get('uni/students/getInfoStudentAboutToExpired', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_INFO_STUDENT_EXPIRED', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getInfoReception({ commit }, params) {
      try {
        const response = await axios.get('uni/reports/reportClassReceiptCourseSemester', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_RECEPTION', data.data || {})
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getLinkAvatar({commit}, link) {
      try {
        const response = await axios.get(`uni/employees/getFileMinioByPathFile?pathFile=${link}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, data: data.data }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
